/**
 * @example
 * ${helperMediaLandscape()} {
 * // любые css стили
 * }
 * ${helperMediaLandscape({ minWidth: 300, maxHeight: 200 })} {
 * // любые css стили
 * }
 */

interface MediaLandscapeProps {
  minWidth?: number;
  maxHeight?: number;
}

export const helperMediaLandscape = (props?: MediaLandscapeProps) => {
  const minWidth = (props && props.minWidth) || 450;
  const maxHeight = (props && props.maxHeight) || 479;

  return `@media (min-width: ${minWidth}px) and (max-height: ${maxHeight}px) and (orientation: landscape)`;
};
